import * as React from 'react';

import { CompaniesList } from '@/components';

const Companies = (): JSX.Element => <CompaniesList />;

export default Companies;
